import FlexChild from "layouts/flex/FlexChild";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import ReactDatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/esm/locale";
import style from "./TestDatePicker.module.css";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import clsx from "clsx";

const DatePicker = forwardRef((props, ref) => {
  const start = new Date();
  const end = new Date(start.getTime() + 1000 * 60 * 60 * 24 * 7);
  const [startDate, setStartDate] = useState(start);

  const [endDate, setEndDate] = useState(end);
  const { type } = props;
  useImperativeHandle(ref, () => ({
    getStartDate() {
      return startDate;
    },
    getEndDate() {
      return endDate;
    },
  }));

  useEffect(() => {
    if (props.startDate) {
      setStartDate(props.startDate);
    }
  }, [props.startDate]);

  useEffect(() => {
    if (props.endDate) {
      setEndDate(props.endDate);
    }
  }, [props.endDate]);
  return (
    <CalendarContainer className={style.container} style={props.style}>
      <HorizontalFlex>
        <ReactDatePicker
          disabled={props.disabled}
          locale={ko} // 언어설정 기본값은 영어
          dateFormat={
            type
              ? type === "date"
                ? "yyyy-MM-dd"
                : "yyyy-MM-dd HH:mm"
              : "yyyy-MM-dd"
          } // 날짜 형식 설정
          className={clsx(style.inputDatePicker, {
            [style.date]: type ? (type === "date" ? true : false) : true,
          })} // 클래스 명 지정 css주기 위해
          // minDate={new Date()}    // 선택할 수 있는 최소 날짜값 지정
          closeOnScroll={true} // 스크롤을 움직였을 때 자동으로 닫히도록 설정 기본값 false
          placeholderText="날짜 선택" // placeholder
          selected={startDate}
          maxDate={props.maxDate ? props.maxDate : new Date()} // 오늘을 넘기는 날은 선택 불가능
          monthsShown={1}
          showTimeInput={type ? (type === "date" ? false : true) : false}
          showTimeSelect={type ? (type === "date" ? false : true) : false}
          onChange={(date) => {
            setStartDate(date);
            props.onChange && props.onChange({ startDate: date });
          }} // 날짜를 선택하였을 때 실행될 함수
        />
        <p>&nbsp;~&nbsp;</p>
        <ReactDatePicker
          disabled={props.disabled}
          locale={ko} // 언어설정 기본값은 영어
          dateFormat={
            type
              ? type === "date"
                ? "yyyy-MM-dd"
                : "yyyy-MM-dd HH:mm"
              : "yyyy-MM-dd"
          } // 날짜 형식 설정
          className={clsx(style.inputDatePicker, {
            [style.date]: type ? (type === "date" ? true : false) : true,
          })} // 클래스 명 지정 css주기 위해
          maxDate={props.maxDate ? props.maxDate : new Date()}
          // minDate={new Date()}    // 선택할 수 있는 최소 날짜값 지정
          closeOnScroll={true} // 스크롤을 움직였을 때 자동으로 닫히도록 설정 기본값 false
          placeholderText="날짜 선택" // placeholder
          selected={endDate} // value
          showTimeInput={type ? (type === "date" ? false : true) : false}
          showTimeSelect={type ? (type === "date" ? false : true) : false}
          onChange={(date) => {
            setEndDate(date);
            props.onChange && props.onChange({ endDate: date });
          }} // 날짜를 선택하였을 때 실행될 함수
        />
      </HorizontalFlex>
      <div
        className={clsx(style.calendar, { [style.disabled]: props.disabled })}
      ></div>
      <div
        className={clsx(style.calendar2, { [style.disabled]: props.disabled })}
      ></div>
    </CalendarContainer>
  );
});

export default DatePicker;
